import { useEffect, useState } from "react";
import { Button, Col, Flex, Form, Input, Menu, Row, Space } from "antd";
import { IconPrimary, Loading, Popup } from ".";
import { DeleteIcon } from "../assets";
import { FaGear } from "react-icons/fa6";
import { useForm } from "antd/es/form/Form";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { addAtc, deleteAtc } from "../redux/apiActions/atcActions";
import { getAtcState } from "../redux/store/getState";

const AtcManager = () => {
  const [form] = useForm();
  const [updateForm] = useForm();
  const dispatch = useAppDispatch();
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const { atc, loading } = useAppSelector(getAtcState);

  useEffect(() => {
    updateForm.setFieldsValue(selectedItem);
  }, [selectedItem, updateForm]);

  return (
    <div className="choose_icon_container">
      <Popup
        openTrigger={
          <Flex
            align="middle"
            gap={10}
            className="choose_icon_item"
            style={{ paddingLeft: 8 }}
          >
            <h6 style={{ fontWeight: 400 }}>Manage ATC</h6>
            <FaGear style={{ marginTop: 4 }} />
          </Flex>
        }
      >
        {(loading.addAtc || loading.getAtc || loading.deleteAtc) && <Loading />}
        <div className="choose_icon_heading">
          <h5>ATC</h5>
        </div>
        <Row gutter={[20, 20]}>
          <Col span={12}>
            <div className="choose_icon_items_container">
              <div className="choose_icon_items">
                <Flex justify="center">
                  {!atc.length ? <h5>No ATC</h5> : null}
                </Flex>

                <Menu
                  style={{ border: "none" }}
                  selectedKeys={[selectedItem?.id]}
                  items={atc.map((item: any) => {
                    const { id, name } = item;
                    return {
                      key: id,
                      label: name,
                      onClick: () => setSelectedItem(item),
                      style: { borderBottom: 0, width: "100%" },
                    };
                  })}
                />
              </div>
            </div>
          </Col>
          <Col span={12}>
            <Space direction="vertical">
              <Space direction="vertical">
                <Form
                  onFinish={(values) => {
                    dispatch(addAtc({ ...values, id: selectedItem?.id }));
                    form.resetFields();
                  }}
                  form={updateForm}
                >
                  <Form.Item name="name">
                    <Input placeholder="Name" />
                  </Form.Item>
                  <Space size="large">
                    <IconPrimary
                      onClick={() => {
                        dispatch(deleteAtc(selectedItem?.id));
                        updateForm.resetFields();
                        setSelectedItem(null);
                      }}
                    >
                      <DeleteIcon />
                    </IconPrimary>
                    {/* <Button type="primary" htmlType="submit">
                      Update
                    </Button> */}
                  </Space>
                </Form>
              </Space>

              <h6 style={{ fontWeight: 400, marginTop: 10 }}>Add ATC</h6>
              <Form
                onFinish={(values) => {
                  dispatch(addAtc(values));
                  form.resetFields();
                }}
                form={form}
              >
                <Form.Item name="name">
                  <Input placeholder="Name" />
                </Form.Item>

                <Flex justify="end">
                  <Button type="primary" htmlType="submit">
                    Add
                  </Button>
                </Flex>
              </Form>
            </Space>
          </Col>
        </Row>
      </Popup>
    </div>
  );
};
export default AtcManager;
